export { HotTopicsMode } from '@conversed/shared/src/central/constants/hot-topics';

export enum HotTopicsPeriod {
  DAILY = 'daily',
  WEEKLY = 'weekly',
}
